<template>
 <el-container id="Home">
    <el-row>
      <el-col :span="24"><div class="grid-content bg-purple-dark"></div></el-col>
    </el-row>

 
    <el-container>
      <!-- 左侧内容 -->
      <el-aside :width="HomeWidth" class="Home_left">
        <el-row class="tac">
          <el-col :span="24">
            <div class="main-title">香味研究所</div>
            <el-menu
              :default-active="$route.path"
              router
              
              :collapse="isCollapse"
              text-color="#fff"
              background-color="#425173"
              class="el-menu-vertical-demo"
            >
              <template v-for="(item, index) in routesData" v-if="!item.hidden">
                <el-submenu v-if="item.leaf" :index="index + ''" >
                  <template slot="title">
                    <!-- <i class="el-icon-location"></i> -->
                    <span slot="title">{{ item.name }}</span>
                  </template>
                  
                    <el-menu-item
                      v-for="child in item.children"
                      :index="child.path"
                      :key="child.path"
                      v-if="!child.hidden"
                      ><i :class="child.iconCls"></i
                      >{{ child.name }}</el-menu-item>
                    </el-submenu>
                </el-submenu>

                <el-menu-item
                  v-if="!item.leaf && item.children.length > 0"
                  :index="item.children[0].path"
                  :key="index"
                >
                  <i :class="item.iconCls"></i>
                  <span slot="title">{{ item.children[0].name }}</span>
                </el-menu-item>
              </template>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>

      <!-- 主体内容 -->
    
      <el-main>

       
  
        <transition name="fade" mode="out-in">
          <div class="main_box">
               <router-view />
          </div>
         
        </transition>

      </el-main>
    </el-container>

  </el-container>
  
</template>

<script>
export default {
  data() {
    return {
      routesData: [],
      routesTitle: "管理平台",

      isCollapse: false,
      HomeWidth: "220px",

      tagIndex: "/desktop",
      tagData: [],

      userList: [
        {
          school: "",
        },
      ],

      // 机器人数据
      classData: [],
    };
  },
  computed: {
    // routes(){
    //   return  this.$router.options[0].childre
    // }
  },
  
  created() {
   
  },
  mounted() {
    this.routesData = this.$router.options.routes;
  },
  methods: {
   
  },

};
</script>

<style scoped lang="less">
#Home {
  width: 100%;
  min-height: calc(100vh - 30px);

  .el-header {
    width: 100%;
    padding: 5px;
    background-color: #222;
  }

  .el-menu{
    border: 0;
  }

  .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }

  // 头部内容
  .top_box {
    width: 100%;
    display: flex;
    align-items: center;
    color: #fff;

    .logo {
      width: 240px;
      margin-top: 3px;
      flex-shrink: 0;

      span {
        margin-left: 10px;
      }
    }

    .top_rigth {
      width: 100%;
      justify-content: space-between;
      padding-right: 20px;
      box-sizing: border-box;
    }

    .opneNav {
      width: 32px;
      height: 32px;
      line-height: 32px;
      background: #777;
      font-size: 20px;
      margin: 0px 15px;
      border-radius: 3px;
      text-align: center;
    }
  }

  .is-active {
    background: #313a51 !important;
    color: #fff !important;
  }

  .main-title {
    height: 50px;
    width: 100%;
    line-height: 50px;
    text-align: center;
    color: #fff;
    background: #529ce8;
    font-size: 17px;
    letter-spacing: 1px;
  }

  .Home_left {
    background:#425173;
    border-right:0px;
    transition: width 0.3s;
    
  }

  // 主要内容
  .el-main {
    padding: 0;

    .main_box {
      padding:0px;
      box-sizing: border-box;
    }
  }

  // 标签起始位置
  .tag_box {
    width: 100%;
    height: 38px;
    overflow: hidden;
    background: #e9e7e7;
    border-bottom: 1px solid #dedede;

    ul {
      width: 100%;
      height: 45px;
      overflow-x: scroll;
      overflow-y: hidden;
      font-size: 14px;
      white-space: nowrap;
      padding-right: 20px;
      padding-bottom: 10px;

      .tagIndex {
        background: #fff;
      }

      li {
        line-height: 30px;
        display: inline-block;
        padding: 5px 8px;
        cursor: pointer;

        i {
          width: 16px;
          height: 16px;
          border-radius: 16px;
          line-height: 16px;
          text-align: center;
        }
        i:hover {
          background: red;
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue